import React, { useRef, useState } from "react";
import logoVideo from '../assets/video/logo.mp4';

export default function InteractiveDemo() {
  const videoRef = useRef(null);
  const [currentView, setCurrentView] = useState('menu');

  const renderMenuView = () => {
    return (
      <div className="flex flex-col gap-6 items-center justify-center mt-12">
        <button
          className="bg-rose-700 hover:bg-rose-800 text-white px-8 py-4 rounded-xl shadow-lg text-xl font-semibold transition-all duration-200"
          onClick={() => setCurrentView('create')}
        >
          Create New Check
        </button>
        <button
          className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl shadow-lg text-xl font-semibold transition-all duration-200"
          onClick={() => setCurrentView('conduct')}
        >
          Conduct Check (Web)
        </button>
        <button
          className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-4 rounded-xl shadow-lg text-xl font-semibold transition-all duration-200"
          onClick={() => setCurrentView('reports')}
        >
          View Reports
        </button>
      </div>
    );
  };

  const renderCreateView = () => {
    return (
      <div className="w-full h-full bg-white p-6 overflow-auto text-left">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Form Builder</h2>
          <button onClick={() => setCurrentView('menu')} className="text-sm text-gray-600 hover:text-gray-800">✕ Close</button>
        </div>
        <div className="space-y-4">
          <input type="text" placeholder="Check Title" className="w-full p-2 border rounded" defaultValue="Safety Inspection" />
          <div className="border rounded p-4 bg-gray-50">
            <div className="mb-2 font-semibold text-sm text-gray-700">Question 1</div>
            <select className="w-full p-2 border rounded mb-2">
              <option>Yes/No</option>
              <option>Text</option>
              <option>Number</option>
              <option>Multiple Choice</option>
            </select>
            <input type="text" placeholder="Enter your question..." className="w-full p-2 border rounded" defaultValue="Are safety barriers in place?" />
          </div>
          <div className="border rounded p-4 bg-gray-50">
            <div className="mb-2 font-semibold text-sm text-gray-700">Question 2</div>
            <select className="w-full p-2 border rounded mb-2">
              <option>Text</option>
              <option>Yes/No</option>
              <option>Number</option>
            </select>
            <input type="text" placeholder="Enter your question..." className="w-full p-2 border rounded" defaultValue="Inspector notes" />
          </div>
          <button className="bg-rose-700 hover:bg-rose-800 text-white px-4 py-2 rounded w-full">+ Add Question</button>
        </div>
      </div>
    );
  };

  const renderConductView = () => {
    return (
      <div className="w-full h-full bg-white p-6 overflow-auto text-left">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Safety Inspection</h2>
          <button onClick={() => setCurrentView('menu')} className="text-sm text-gray-600 hover:text-gray-800">✕ Close</button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block font-semibold mb-2 text-gray-700">Are safety barriers in place?</label>
            <div className="flex gap-4">
              <button className="bg-green-600 text-white px-6 py-2 rounded">Yes</button>
              <button className="bg-gray-300 text-gray-700 px-6 py-2 rounded">No</button>
            </div>
          </div>
          <div>
            <label className="block font-semibold mb-2 text-gray-700">Inspector notes</label>
            <textarea className="w-full p-2 border rounded" rows="3" defaultValue="All barriers checked and secure"></textarea>
          </div>
          <div>
            <label className="block font-semibold mb-2 text-gray-700">Photo evidence</label>
            <div className="border-2 border-dashed border-gray-300 rounded p-4 text-center text-gray-500">
              📷 Tap to add photo
            </div>
          </div>
          <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded w-full font-semibold">Submit Check</button>
        </div>
      </div>
    );
  };

  const renderReportsView = () => {
    return (
      <div className="w-full h-full bg-white p-6 overflow-auto text-left">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-800">Completed Checks</h2>
          <button onClick={() => setCurrentView('menu')} className="text-sm text-gray-600 hover:text-gray-800">✕ Close</button>
        </div>
        <div className="space-y-3">
          <div className="border rounded p-4 bg-gray-50 hover:bg-gray-100 cursor-pointer">
            <div className="font-semibold text-gray-800">Safety Inspection</div>
            <div className="text-sm text-gray-600">20 Nov 2025, 14:30</div>
            <div className="text-xs text-green-600 mt-1">✓ Completed</div>
          </div>
          <div className="border rounded p-4 bg-gray-50 hover:bg-gray-100 cursor-pointer">
            <div className="font-semibold text-gray-800">Equipment Check</div>
            <div className="text-sm text-gray-600">19 Nov 2025, 09:15</div>
            <div className="text-xs text-green-600 mt-1">✓ Completed</div>
          </div>
          <div className="border rounded p-4 bg-gray-50 hover:bg-gray-100 cursor-pointer">
            <div className="font-semibold text-gray-800">Daily Site Audit</div>
            <div className="text-sm text-gray-600">18 Nov 2025, 16:45</div>
            <div className="text-xs text-green-600 mt-1">✓ Completed</div>
          </div>
        </div>
        <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded w-full font-semibold mt-4">📄 Export All Reports</button>
      </div>
    );
  };

  return (
    <div className="flex items-center justify-center">
      <div className="relative w-[440px] h-[600px] sm:w-[520px] sm:h-[680px] bg-black rounded-[40px] border-[10px] border-gray-900 overflow-hidden shadow-2xl flex items-center justify-center">
        <div className="absolute top-4 left-1/2 -translate-x-1/2 z-20 flex gap-2 items-center justify-center">
          <div className="w-2 h-2 rounded-full bg-gray-800" />
          <div className="w-3.5 h-1 rounded-full bg-gray-700/80" />
          <div className="w-3.5 h-1 rounded-full bg-gray-700/80" />
          <div className="w-2 h-2 rounded-full bg-gray-800" />
        </div>
        <div className="absolute inset-[12px] bg-black flex items-center justify-center overflow-hidden rounded-[32px]">
          {currentView === 'menu' && (
            <video
              ref={videoRef}
              src={logoVideo}
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-contain absolute z-0"
              style={{ filter: "brightness(1.1)" }}
            />
          )}
          <div className="relative z-10 flex flex-col items-center justify-center w-full h-full">
            {currentView === 'menu' && renderMenuView()}
            {currentView === 'create' && renderCreateView()}
            {currentView === 'conduct' && renderConductView()}
            {currentView === 'reports' && renderReportsView()}
          </div>
        </div>
        <div
          className="absolute -inset-1 pointer-events-none rounded-[40px] transition-opacity duration-1000"
          style={{
            background: `radial-gradient(circle at center, rgba(34,197,94,0.3), transparent 80%)`,
            opacity: 0.5,
          }}
        />
      </div>
    </div>
  );
}

